import { AlertProps as Mui5AlertProps, default as Mui5Alert } from '@mui/material/Alert'
import { forwardRef, MouseEventHandler } from 'react'
import { NotificationContent } from '../other/notification/NotificationContent'

export type NotificationSeverities = Mui5AlertProps['severity']
export type NotificationVariants = Mui5AlertProps['variant']
export type NotificationProps = {
  title: string
  message: string
  severity?: NotificationSeverities
  primaryButtonLabel?: string
  secondaryButtonLabel?: string
  onClickPrimaryButton?: MouseEventHandler
  onClickSecondaryButton?: MouseEventHandler
}

// * MUI Alert API Spec  https://mui.com/material-ui/react-alert/
export const Notification = forwardRef<HTMLDivElement, NotificationProps>((props, ref) => {
  void ref
  let {
    severity = 'info',
    primaryButtonLabel,
    secondaryButtonLabel,
    onClickPrimaryButton,
    onClickSecondaryButton,
    title,
    message,
  } = props

  return (
    // Added padding using sx prop because MUI Alert does not have padding 12 and fixed with
    <Mui5Alert sx={{ padding: '12px', width: 384 }} variant={'standard'} icon={false} severity={severity}>
      <NotificationContent
        title={title}
        message={message}
        severity={severity}
        primaryButtonLabel={primaryButtonLabel}
        secondaryButtonLabel={secondaryButtonLabel}
        onClickPrimaryButton={onClickPrimaryButton}
        onClickSecondaryButton={onClickSecondaryButton}
      />
    </Mui5Alert>
  )
})

// extend the spec
declare module '@mui/material/Alert' {
  interface AlertPropsColorOverrides {
    neutral: true
  }
}
